<template>
  <b-modal
    id="modalJustificativa"
    ref="modalJustificativa"
    hide-footer
    hide-header
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <validation-observer ref="validacao">
          <b-row class="mt-1">
            <b-col
              cols="12"
              style="text-align:left;"
            >
              <h4>
                Informe a justificativa da dispensa
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Justificativa"
              >
                <b-textarea
                  v-model="justificativa"
                  placeholder="Justifique"
                  rows="5"
                  max-rows="6"
                  :state="!errors[0] || errors[0] === '' ? null : false"
                />
                <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="6">
              <b-btn
                variant="success"
                class="w-100"
                @click="aplicar()"
              >Confirmar</b-btn>
            </b-col>
            <b-col cols="6">
              <b-btn
                variant="danger"
                class="w-100"
                @click="cancelar()"
              >Cancelar</b-btn>
            </b-col>
          </b-row>
        </validation-observer>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'JustificativaDispensa',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      justificativa: '',
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.modalJustificativa.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.modalJustificativa.hide()
      this.$emit('cancelar')
    },
    aplicar() {
      this.$refs.validacao.validate()
        .then(success => {
          if (success) {
            const justSemEspaco = this.justificativa.replace(/\s+/g, '')
            if (!this.justificativa) {
              this.$erro('A justificativa da dispensa é obrigatório.')
            } else if (justSemEspaco.length < 10) {
              this.$erro('A justificativa deve ter no mínimo 10 caracteres')
            } else {
              this.$refs.modalJustificativa.hide()
              this.$emit('aplicar', { justificativa: this.justificativa })
            }
          }
        })
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return 'A justificativa é obrigatória'
      }
      return erro
    },
  },
}
</script>
